<div class="payments-page">
  <header class="payments-header">
    <div class="header-inner">
      <div class="header-brand">
        <a
          class="brand"
          href="https://misericordia.net/"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Vai al sito della Misericordia di Borgo San Lorenzo">
          <img
            src="assets/img/misericordia-logo-header.png"
            alt="Confraternita di Misericordia di Borgo San Lorenzo">
        </a>
        <span class="section-tag">Sezione Pagamenti</span>
      </div>
    </div>
  </header>

  <main>
    <router-outlet />
  </main>

  <footer class="payments-footer">
    <div class="footer-inner">
      <a
        class="footer-brand"
        href="https://misericordia.net/"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Vai al sito della Misericordia di Borgo San Lorenzo">
        <img
          src="assets/img/logo.png"
          alt="Stemma Confraternita di Misericordia di Borgo San Lorenzo">
      </a>

      <div class="footer-info">
        <p class="footer-name">Confraternita di Misericordia di Borgo San Lorenzo</p>
        <address class="footer-address">
          <span>Via Giotto, 30 — 50032 Borgo San Lorenzo (FI)</span>
          <span>Tel. <a href="tel:0558494118">055 8494118</a></span>
          <span>P. IVA 01343220487</span>
        </address>
        <p class="footer-policies">
          <a routerLink="/pagamenti/privacy">Privacy Policy</a>
          <span aria-hidden="true">·</span>
          <a routerLink="/pagamenti/cookie">Cookie Policy</a>
        </p>
        <p class="footer-help">
          Hai bisogno di aiuto? Telefona allo
          <a href="tel:0558494118">055 8494118</a>
          o vieni in sede.
        </p>
      </div>
    </div>

    <p class="footer-credit">
      Creato da
      <a href="https://wallnet.it" target="_blank" rel="noopener noreferrer">Wallnet</a>
    </p>
  </footer>
</div>
